import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { Router, RouterOutlet } from '@angular/router';
import { APP_SHORT_NAME } from '@pcplus/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ThemeService } from '../../services/theme/theme.service';
import { APP_FOOTER_LINK, APP_FOOTER_TEXT } from '../../tokens';
import { SideMenuService } from '../side-menu/side-menu.service';
import { Theme } from '../theme-select/theme';
import { FlexModule } from '@angular/flex-layout/flex';
import { Dir } from '@angular/cdk/bidi';
import { HeaderComponent } from '../header/header.component';
import { NgClass, NgStyle } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { SizeMonitorDirective } from '../../directives/size-monitor.directive';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'pcp-envelope',
    templateUrl: './envelope.component.html',
    styleUrls: ['./envelope.component.scss'],
    imports: [FlexModule, Dir, HeaderComponent, RouterOutlet, MatSidenavContainer, NgClass, ExtendedModule, MatSidenav, NgStyle, SideMenuComponent, MatSidenavContent, SizeMonitorDirective, MatDivider]
})
export class EnvelopeComponent implements OnInit, OnDestroy {
  constructor(
    private cd: ChangeDetectorRef,
    public sideMenuService: SideMenuService,
    private themeService: ThemeService,
    @Inject(APP_SHORT_NAME) public appShortName: string,
    @Inject(APP_FOOTER_LINK) public appFooterLink: string,
    @Inject(APP_FOOTER_TEXT) public appFooterText: string,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => cd.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  mobileQuery: MediaQueryList;
  overRequested = false;
  themeClass = 'default-theme';
  private _mobileQueryListener: () => void;
  private onDestroy$ = new Subject<void>();
  username: string | null = null;
  currentYear = new Date().getUTCFullYear();

  @ViewChild('snav', { static: true })
  sideNav: MatSidenav | null = null;

  // sizeChanged() {
  //   this.cd.detectChanges();
  // }
  ngOnInit() {
    this.themeService.themeChange$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((t) => {
        this.themeClass = t.themeName;
      });

    this.sideMenuService.overRequested$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((val) => (this.overRequested = val));
    this.sideMenuService.sideMenu$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((item) => {
        if (
          this.sideNav &&
          (!item ||
            item.toggle ||
            (item.open && !this.sideNav.opened) ||
            (item.close && this.sideNav.opened))
        ) {
          this.sideNav.toggle().catch((error) => console.log(error));
          return;
        }
      });

    // this.config.sideMenuActions.forEach((a: SideMenuAction) => {
    //   this.monitorPermissions(a);
    // });
  }

  navigateToAppLink() {
    window.open(this.appFooterLink, '_blank');
  }

  changeTheme(theme: Theme) {
    this.themeService.changeTheme(theme);
  }

  // monitorPermissions(action: SideMenuAction) {
  //   if (action.adminOnly) {
  //     this.perm
  //       .isAdministrator()
  //       .pipe(takeUntil(this.onDestroy$))
  //       .subscribe((p) => {
  //         setTimeout(() => {
  //           this.addOrRemoveAction(p, action);
  //         }, 0);
  //       });
  //   } else {
  //     if (action.activity) {
  //       this.perm
  //         .hasPermission(Permission.Read, action.activity)
  //         .pipe(takeUntil(this.onDestroy$))
  //         .subscribe((p) => {
  //           setTimeout(() => {
  //             this.addOrRemoveAction(p, action);
  //           }, 0);
  //         });
  //     } else {
  //       if (!this.actions.some((a) => a.id === action.id)) {
  //         this.actions = this.actions.concat(action);
  //       }
  //     }
  //   }
  // }

  // private addOrRemoveAction(p: boolean, action: SideMenuAction) {
  //   if (p) {
  //     if (!this.actions.some((a) => a.id === action.id)) {
  //       this.actions = this.actions.concat(action);
  //     }
  //   } else {
  //     this.actions = this.actions.filter((a) => a.id !== action.id);
  //   }
  // }

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
